<div *ngIf="!isShowOption" class="container">
    <div class="title-container">
        <h2 class="mat-title" *ngIf="!isEditing">Ajout d'une négociation garantie</h2>
        <h2 class="mat-title" *ngIf="isEditing && !data.isDuplication">Modification d'une négociation garantie</h2>
        <h2 class="mat-title" *ngIf="isEditing && data.isDuplication">Duplication d'une négociation garantie</h2>
    </div>

    <div class="tv-ns-custom-horizontal-divider"></div>

    <div class="bloc-container">
        <h4 class="red-title">Général</h4>
        <div class="inputs-container inputs-container-top">
            <!-- Target -->
            <div class="tv-rect-input-extensible flex-auto">
                <mat-form-field>
                    <mat-label>Cible</mat-label>
                    <input
                            class="tv-ns-select-option"
                            type="text"
                            matInput
                            [formControl]="targetFormControl"
                            [matAutocomplete]="auto"
                    >
                    <mat-autocomplete autoActiveFirstOption class="tv-custom-always-visible-scroll-bar" #auto="matAutocomplete"
                                      [displayWith]="displayTarget">
                        <mat-option *ngFor="let item of filteredTargetList | async" class="tv-ns-select-option"
                                    [value]="item">
                            {{ item.name }} ({{ item.id}})
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <div class="tv-input-error-message" *ngIf="targetFormControl.touched && targetFormControl.hasError('required')">
                    <mat-icon class="tv-input-error-icon">error</mat-icon>
                    <span class="tv-input-error-text">Veuillez choisir une cible</span>
                </div>
            </div>

            <!-- Date Range -->
            <app-date-range-picker
                    [screenFilterForm]="negotiationDateForm"
                    [paramStartDate]="negotiationDateForm.get('startDate').value"
                    [paramEndDate]="negotiationDateForm.get('endDate').value"
                    [isRestrictedToParamDates]="true"
                    [styleType]="'squared'">
            </app-date-range-picker>

            <!-- CA in €  -->
            <div *ngIf="this.isGuarantee" class="tv-rect-input-extensible width-180px">
                <mat-form-field>
                    <mat-label>Montant remise €</mat-label>
                    <input type="number"
                           matInput
                           [formControl]="budgetFormControl">
                </mat-form-field>
                <div class="tv-input-error-message" *ngIf="budgetFormControl.touched && budgetFormControl.hasError('required')">
                    <mat-icon class="tv-input-error-icon">error</mat-icon>
                    <span class="tv-input-error-text">Veuillez renseigner une valeur</span>
                </div>
                <div class="tv-input-error-message" *ngIf="budgetFormControl.touched && budgetFormControl.hasError('min')">
                    <mat-icon class="tv-input-error-icon">error</mat-icon>
                    <span class="tv-input-error-text">Supérieure à égale 0</span>
                </div>
            </div>

            <!-- NCT Rate  -->
            <div class="tv-rect-input-extensible width-180px">
                <mat-form-field>
                    <mat-label>taux NCT %</mat-label>
                    <input type="number"
                           matInput
                           [formControl]="nctRateFormControl"
                           (blur)="enforceNegativeNctRate()">
                </mat-form-field>
                <div class="tv-input-error-message" *ngIf="nctRateFormControl.touched && nctRateFormControl.hasError('required')">
                    <mat-icon class="tv-input-error-icon">error</mat-icon>
                    <span class="tv-input-error-text">Veuillez renseigner une valeur</span>
                </div>
                <div class="tv-input-error-message"
                     *ngIf="nctRateFormControl.touched && (nctRateFormControl.hasError('min') || nctRateFormControl.hasError('max'))">
                    <mat-icon class="tv-input-error-icon">error</mat-icon>
                    <span class="tv-input-error-text">Compris entre -999 et 0</span>
                </div>
            </div>
        </div>
    </div>

    <div class="bloc-container-row">
        <!-- Pack -->
        <div class="bloc-container-pack">
            <h4 class="red-title"> Pack </h4>
            <div class="inputs-container">
                <div class="tv-container-select-white-rect-extensible flex-auto">
                    <mat-form-field>
                        <mat-label>Pack</mat-label>
                        <mat-select panelClass="tv-custom-always-visible-scroll-bar" [formControl]="contractPackFormControl">
                            <mat-option *ngFor="let pack of contractPackList" class="tv-ns-select-option"
                                        [value]="pack">
                                {{ pack.label }} ({{ pack.id }})
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <div class="tv-input-error-message" *ngIf="contractPackFormControl.touched && contractPackFormControl.hasError('required')">
                        <mat-icon class="tv-input-error-icon">error</mat-icon>
                        <span class="tv-input-error-text">Veuillez renseigner une valeur</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Channel -->
        <div class="bloc-container-channel">
            <h4 class="red-title"> Chaines </h4>
            <div class="inputs-container">
                <!-- Search Item -->
                <div class="tv-rect-input-extensible flex-auto">
                    <mat-form-field>
                        <mat-label>Rechercher</mat-label>
                        <input
                                class="tv-ns-select-option"
                                matInput
                                type="text"
                                aria-label="Number"
                                [formControl]="searchChannelFormControl"
                                [matAutocomplete]="channelAuto"
                        >
                        <mat-autocomplete autoActiveFirstOption class="tv-custom-always-visible-scroll-bar" #channelAuto="matAutocomplete"
                                      [displayWith]="displayContractPackChannel">
                            <mat-option *ngFor="let packChannel of filteredContractPackChannelList | async"
                                        class="tv-ns-select-option"
                                        [value]="packChannel">
                                <img *ngIf="packChannel.channel && packChannel.channel?.logo"
                                     class="channel-logo"
                                     src="{{ packChannel.channel.logo }}" alt="logo"/>
                                <span *ngIf="packChannel.channel && packChannel.channel.name"
                                      class="text">{{ packChannel.channel.name }}
                                    - {{ packChannel.rate}} %</span>
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>

                <!-- List All Channels -->
                <button [disabled]="! filteredContractPackChannelList"
                        (click)="listAllChannels()"
                        class="tv-round-icon-button-icon-medium-light-blue all-option-button">
                    <mat-icon>list</mat-icon>
                </button>
            </div>
        </div>
    </div>

    <!-- Channels Repartition -->
    <div class="bloc-container" *ngIf="isChannelBlockAdded">
        <ng-container>
            <h4 class="red-title"> Répartition </h4>
            <div class="container-chips" *ngIf="selectedChannels.size > 0">
                <div class="block-chip" *ngFor="let item of selectedChannels">
                    <img *ngIf="item.channel && item.channel?.logo"
                         class="channel-logo" src="{{ item.channel.logo }}" alt="logo"/>
                    <span *ngIf="item.channel && item.channel.name" class="text">{{ item.channel.name }}
                        - {{ item.rate || 0 }} %</span>
                    <mat-icon (click)="removeChannelItem(item)">cancel</mat-icon>
                </div>
            </div>
        </ng-container>
    </div>

    <!-- Condition -->
    <div class="add-category-bloc-container" *ngIf="! isCategoryBlockAdded; else conditionTemplate">
        <span>Conditions</span>
        <div>
            <mat-icon class="type-icon" svgIcon="add-circle-fill" (click)="addCategoryBloc('Inclus')">
            </mat-icon>
            <!--            <mat-icon class="type-icon" svgIcon="delete-circle-fill" (click)="addCategoryBloc('Exclus')">-->
            <!--            </mat-icon>-->
        </div>
    </div>

    <!-- Condition Template -->
    <ng-template #conditionTemplate>
        <div class="bloc-container">
            <h4 class="red-title">{{ categoryConditionType }}</h4>
            <div class="inputs-container">
                <!-- Category -->
                <div class="tv-container-select-white-rect-extensible">
                    <mat-form-field>
                        <mat-label>Catégorie de la négo</mat-label>
                        <mat-select panelClass="tv-custom-always-visible-scroll-bar" [formControl]="categoryTypeFormControl">
                            <mat-option *ngFor="let category of categoryTypeList" class="tv-ns-select-option"
                                        [value]="category">
                                {{ category.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <!-- Search Item -->
                <div class="tv-rect-input-extensible">
                    <mat-form-field>
                        <mat-label>Rechercher</mat-label>
                        <input
                                class="tv-ns-select-option"
                                type="text"
                                aria-label="Number"
                                matInput
                                [formControl]="searchFormControl"
                                [matAutocomplete]="auto"
                        >
                        <mat-autocomplete autoActiveFirstOption class="tv-custom-always-visible-scroll-bar" #auto="matAutocomplete"
                                      [displayWith]="displayItem">
                            <mat-option *ngFor="let item of filteredItemList | async" class="tv-ns-select-option"
                                        [value]="item">
                                {{ item.name }} ({{ item.id}})
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>

                <!-- List All Option -->
                <button [disabled]="! filteredItemList"
                        (click)="listAllItems()"
                        class="tv-round-icon-button-icon-medium-light-blue">
                    <mat-icon>list</mat-icon>
                </button>

                <!-- Delete condition icon-->
                <button (click)="removeCondition()" class="tv-round-icon-button-icon-medium-light-blue">
                    <mat-icon>delete</mat-icon>
                </button>
                <!--                <mat-icon (click)="removeCondition()">delete_outline</mat-icon>-->
            </div>

            <!-- Display items -->
            <div class="container-chips" *ngIf="selectedOptions.size > 0">
                <div class="block-chip" *ngFor="let item of selectedOptions">
                    <span class="text">{{ item.categoryType?.name.substring(0, 2) }}
                        - {{ item.categoryValue?.name }}</span>
                    <mat-icon (click)="removeItem(item)">cancel</mat-icon>
                </div>
            </div>
        </div>
    </ng-template>

    <div class="button-edit">
        <button class="tv-ns-secondary-large-button-on-light-bg" (click)="onCancelUpdateButtonClick()">Annuler
        </button>
        <button class="tv-ns-validation-large-button" (click)="onValidationButtonClick()">Valider
        </button>
        <div *ngIf="isSaving" class="main-validation-container" id="onLoading">
            <mat-spinner diameter="30" class="light-spinner"></mat-spinner>
        </div>
    </div>
</div>
